import { useEffect } from "react";

const AlertDesign = ({ message, type = "info", onClose, autoClose = true, duration = 3000 }) => {
  // Automatically close after duration (default 3 sec)
  useEffect(() => {
    if (autoClose && onClose) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose]);

  // Color styles based on type
  const typeStyles = {
    success: "bg-green-100 border-green-500 text-green-700",
    error: "bg-red-100 border-red-500 text-red-700",
    warning: "bg-yellow-100 border-yellow-500 text-yellow-700",
    info: "bg-blue-100 border-blue-500 text-blue-700",
  };

  return (
    <div
      className={`border-l-4 p-4 rounded-md shadow-sm mb-3 transition-all ${typeStyles[type]}`}
      role="alert"
    >
      <div className="flex justify-between items-center">
        <span className="font-medium">{message}</span>
        {onClose && (
          <button
            className="ml-4 text-sm font-bold"
            onClick={onClose}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default AlertDesign;
